import { AlertTriangle, CheckCircle2, Circle } from "lucide-react";

const STYLE = {
  faltante: ["bg-muted text-[#575757]", Circle, "text-[#C9C4BC]"],
  observado: ["bg-amber-50 text-amber-800", AlertTriangle, "text-amber-600"],
  recibido: ["bg-emerald-50 text-emerald-800", CheckCircle2, "text-emerald-600"],
  validado: ["bg-emerald-100 text-emerald-900", CheckCircle2, "text-emerald-700"],
};

export const DocChecklist = ({ items }) => {
  const done = items.filter((i) => i.done).length;
  const observed = items.filter((i) => i.state === "observado").length;
  return (
    <div data-testid="doc-checklist">
      <div className="flex items-center justify-between text-xs mb-2">
        <span data-testid="checklist-progress" className="font-semibold">{done} de {items.length} documentos listos</span>
        {observed > 0 && <span data-testid="checklist-observed" className="text-amber-700 font-semibold">{observed} con observaciones</span>}
      </div>
      <div className="h-2 rounded-full bg-muted overflow-hidden mb-3"><div className="h-full bg-[#1E9E6A] transition-[width] duration-500" style={{ width: `${items.length ? (done / items.length) * 100 : 0}%` }} /></div>
      <ul className="grid sm:grid-cols-2 gap-2 text-sm">
        {items.map((c) => { const [cls, Icon, ic] = STYLE[c.state || "faltante"]; return (
          <li key={c.doc_type} data-testid={`checklist-${c.doc_type}`} data-state={c.state || "faltante"} className={`flex items-start gap-2 rounded-lg px-3 py-2 min-w-0 overflow-hidden ${cls}`}>
            <Icon size={14} className={`${ic} mt-0.5 shrink-0`} />
            <div className="min-w-0">
              <div>{c.label}</div>
              {c.state === "observado" && c.observations?.[0] && <div className="text-[11px] opacity-80 truncate" title={c.observations.join(" · ")}>{c.observations[0]}</div>}
              {c.via?.startsWith("Conexión SAT") && <div className="text-[11px] opacity-80">Generado vía SAT</div>}
            </div>
          </li>); })}
      </ul>
      <div className="flex flex-wrap gap-3 mt-2 text-[10px] text-[#8A8A8A]"><span className="flex items-center gap-1"><Circle size={10} /> Pendiente</span><span className="flex items-center gap-1"><AlertTriangle size={10} className="text-amber-600" /> Recibido con observaciones</span><span className="flex items-center gap-1"><CheckCircle2 size={10} className="text-emerald-600" /> Recibido / validado</span></div>
    </div>
  );
};
